window.mixitup = require('mixitup');
window.jsSocials = require('jssocials');

import {
	Modal,
	Pushpin
} from 'materialize-css';

jQuery(function ($) {
	$('[data-toggle="shuffle"]').each(function () {
		var $this = $(this);
		var grid = mixitup(this, {
			selectors: {
				control: "[data-mixitup-control]"
			},
			callbacks: {
				onMixClick: function (state, e) {
					e.stopPropagation();
				}
			}
		});

		var $filters = $($this.data("filter"));
		$("input", $filters).on("change", function () {
			grid.filter(".base-" + $(this).val());
		});
	});

	$('[data-toggle="share"]').each(function () {
		$(this).jsSocials({
			showLabel: false,
			shareIn: "popup",
			shares: [{
				share: "facebook",
				logo: "fab fa-facebook"
			}, {
				share: "twitter",
				logo: "fab fa-twitter-square"
			}, {
				share: "linkedin",
				logo: "fab fa-linkedin"
			}, {
				share: "pinterest",
				logo: "fab fa-pinterest"
			}, {
				share: "email",
				logo: "fas fa-at"
			}]
		});
	});

	$('[data-toggle="share-buttons"]').each(function () {
		$(this).jsSocials({
			showLabel: true,
			shareIn: "popup",
			shares: [{
				share: "facebook",
				logo: "fab fa-facebook"
			}, {
				share: "twitter",
				logo: "fab fa-twitter-square"
			}, {
				share: "linkedin",
				logo: "fab fa-linkedin"
			}, {
				share: "pinterest",
				logo: "fab fa-pinterest"
			}, {
				share: "email",
				logo: "fas fa-at"
			}]
		});
	});

	$(".modal").each(function () {
		M.Modal.init($(this));
	});

	$('[data-toggle="affix"]').each(function () {
		var $this = $(this);
		var $target = $this.parent();

		$this.css("width", $this.outerWidth() + "px");

		M.Pushpin.init($this, {
			top: $target.offset().top,
			bottom: $target.offset().top + $target.height() - ($this.outerHeight() + 10),
			offset: 10
		});
	});
}(jQuery));